import { render, staticRenderFns } from "./tablePermissionAction.vue?vue&type=template&id=116de86c&"
import script from "./tablePermissionAction.vue?vue&type=script&lang=js&"
export * from "./tablePermissionAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports